module.exports = __webpack_public_path__ + "static/GorditaRegular-Italic-9b098595e73e9b62251117f9b5362cc7.woff";